import { useRolodexEntries } from 'features/rolodex'
import { useMemo } from 'react'
import { RolodexEntryType } from 'types'

export const useSiteFilesData = (
  siteID: string | undefined,
  unitID: string | undefined
) => {
  const {
    reports,
    isLoading,
    hasEverLoaded,
    forceRefresh: refreshData,
  } = useRolodexEntries(
    !siteID || !unitID
      ? undefined
      : [
          {
            type: RolodexEntryType.REPORT,
            tags: { site: siteID },
            filters: [
              {
                key: 'units',
                op: 'contains',
                value: [unitID],
              },
            ],
          },
          {
            type: RolodexEntryType.REPORT,
            tags: { unit: unitID },
          },
        ]
  )

  return useMemo(() => {
    return {
      reports,
      isLoading,
      hasEverLoaded,
      refreshData,
    }
  }, [reports, refreshData, isLoading, hasEverLoaded])
}
